import React, { useState, useEffect } from "react";

const parentClassname = "react-form";

const SearchSelect = props => {
    const componentClassname = parentClassname
        ? `${parentClassname}__field`
        : "field";
    const labelPlaceholderClassname = props.labelplaceholder
        ? `${componentClassname}__label--labelplaceholder`
        : "";

    const [value, setValue] = useState(props.defaultValue);
    const [focused, setFocused] = useState(false);
    const [searchValue, setSearchValue] = useState(props.defaultValue);

    // use effect for value handling
    useEffect(() => {
        // set real input value
        props.inputElement.ref.current.value = value;
        if (props.onChange) {
            // push value to react-form state
            props.onChange({
                target: {
                    value: value,
                    name: props.name,
                },
            });
            setSearchValue(value);
        }
    }, [value]);

    // Event handling
    const handleSearchInputOnChange = event => {
        setSearchValue(event.target.value);
        event.target.value.length > 1 ? setFocused(true) : setFocused(false);
    };

    const handleSearchInputOnBlur = event =>
        setTimeout(() => {
            setFocused(false);
            setSearchValue(value);
        }, 150);

    const handleSearchResultOnClick = newValue =>
        setTimeout(() => {
            setFocused(false);
            setValue(newValue);
        }, 150);

    const highlightSubstring = (string, substring) => {
        const regex = new RegExp(substring, "gi");
        return string.replace(regex, match => {
            return `<strong>${match}</strong>`;
        });
    };

    return (
        <div
            className={`${componentClassname} 
                ${componentClassname}--search-select
                ${props.classes.inheritedClasses} 
                ${props.classes.isDisabled} 
                ${props.classes.isIncomplete} 
                ${props.classes.isFocused} 
                ${props.classes.hasValue}
                ${props.classes.isValid}
                ${props.classes.isInvalid}
            `}
        >
            <label htmlFor={`${props.name}-search`}>
                {/*label*/}
                {props.label ? (
                    <div
                        className={`${componentClassname}__label  ${labelPlaceholderClassname}`}
                    >
                        <div
                            className={`${componentClassname}__label__inner`}
                            id={props.accessibilityIds.label}
                            dangerouslySetInnerHTML={{
                                __html: props.label,
                            }}
                        ></div>
                    </div>
                ) : null}

                {/* search input */}
                <div className={`search-select ${focused ? "is-focused" : ""}`}>
                    <div className="search-select__search">
                        <input
                            className="search-select__search__input"
                            type="text"
                            id={`${props.name}-search`}
                            name={`${props.name}-search`}
                            placeholder={props.placeholder}
                            value={searchValue}
                            onChange={handleSearchInputOnChange}
                            onBlur={handleSearchInputOnBlur}
                            autoComplete="off"
                        />
                        <label
                            htmlFor={`${props.name}-search`}
                            className="search-select__search__icon icon icon-search"
                            aria-hidden="true"
                        ></label>
                    </div>

                    <div className="search-select__results">
                        {props.children.map((option, index) => {
                            if (
                                (option.props.value && !searchValue) ||
                                (option.props.children[0] &&
                                    option.props.children[0]
                                        .toLowerCase()
                                        .includes(searchValue.toLowerCase()))
                            ) {
                                return (
                                    <div
                                        key={index}
                                        className="search-select__results__item"
                                        onClick={() =>
                                            handleSearchResultOnClick(
                                                option.props.value
                                            )
                                        }
                                    >
                                        {/* substring highlighting */}
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: highlightSubstring(
                                                    option.props.children[0],
                                                    searchValue
                                                ),
                                            }}
                                        />
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </div>

                {/* hidden input value element*/}
                {props.inputElement}
            </label>

            {/*errors*/}
            {!props.hideErrors &&
            props.errors &&
            props.errors.length &&
            props.showErrors ? (
                <div className={`${componentClassname}__errors`}>
                    <div
                        className={`${componentClassname}__errors__item`}
                        id={props.accessibilityIds.error}
                        dangerouslySetInnerHTML={{
                            __html: props.errors[0],
                        }}
                    ></div>
                </div>
            ) : null}

            {/*info*/}
            {props.info ? (
                <div
                    className={`${componentClassname}__info`}
                    id={props.accessibilityIds.description}
                    dangerouslySetInnerHTML={{
                        __html: props.info,
                    }}
                ></div>
            ) : null}
        </div>
    );
};

export default SearchSelect;
